<template>
  <div :style="style" class="control-container">
    <div class="control-row title">
        <CktextComponent :rawHtml="control.data.data.title">    
        </CktextComponent>
    </div>
    <div class="control-row">
        <CktextComponent :rawHtml="control.data.data.subtitle">    
        </CktextComponent>
    </div>
    <div class="control-row">
      <div class="field-radiobutton">
            <RadioButton name="gender" value="m" v-model="gender" />
            <div class="label">{{$t('message.male')}}</div>
      </div>
      <div class="field-radiobutton">
            <RadioButton name="gender" value="f" v-model="gender" />
            <div class="label">{{$t('message.female')}}</div>
      </div>
    </div>   
  </div>
</template>

<script>
import RadioButton from 'primevue/radiobutton';
import CktextComponent from '../CkText.vue';

export default {
  name: 'GenderControl',
  components: {
    RadioButton,
    CktextComponent
  },
  data(){
    return {
      valid:true,
      submitted:false,
      style:'',
      gender:'m'
    }
  },
  props: {
    control: null
  },
  methods:{
    validateData(){
      return {
        valid:true,
        data:this.gender,
        type:1
      };
    }
  },
  created(){
    
    this.style=this.$common.generateStyle(this.control.data.style);

    this.gender=this.control.data.data.selection;

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.control-container:last-child{
      margin-bottom: 0px;
  }
  .control-row{
      margin-bottom: 10px;
      text-align:left;
  }

  .title{
      display: flex;
  }
  .required{
    color:#f7363f;
  }
  
  .field-radiobutton{
    display: flex;
    margin-bottom: 10px;
    align-items: center;
  }
  .label{
    margin-left:0.5rem;
  }
  
</style>